import { keepPreviousData,useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import queryKeys from '@/configs/react-query-keys';
import useAppInit from '@/hooks/domain/App/useAppInit';
import service from '@/services/index';
import { CUSTOMER_DOMAIN } from '@/types/customerConst';

type Props = {
  alias: string;
  selectedDomain: CUSTOMER_DOMAIN;
  selectedDomainAttr: FilterOptionT;
};

const useFetchSearchCustomerSegmentTrendData = ({
  alias: topicAlias,
  selectedDomain,
  selectedDomainAttr,
}: Props) => {
  const appInit = useAppInit();
  const fetchTrend = useCallback(async () => {
    let fetcher;
    if (selectedDomain === CUSTOMER_DOMAIN.ACCOUNT) {
      fetcher = service.globalSearch.fetchAccountDist;
    } else {
      fetcher = service.globalSearch.fetchContactDist;
    }
    const res = await fetcher(topicAlias, selectedDomainAttr.columnKey);
    return res;
  }, [topicAlias, selectedDomain, selectedDomainAttr.columnKey]);

  const { data: trendData, isFetching: trendLoading } = useQuery({
    queryKey: [
      queryKeys.search.SEARCH_DETAIL,
      queryKeys.search.SEARCH_RESULT_CUSTOMER_TREND,
      topicAlias,
      selectedDomain,
      selectedDomainAttr.columnKey,
    ],
    queryFn: () => fetchTrend(),
    placeholderData: keepPreviousData,
    enabled: appInit,
  });

  return {
    trendLoading,
    trendData,
  };
};

export default useFetchSearchCustomerSegmentTrendData;
